import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "../../../router/all_routes";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { Toast } from "react-bootstrap";
import Cookies from "js-cookie";
import { InactivityContext } from "../InactivityContext";
type PasswordField =
  | "oldPassword"
  | "newPassword"
  | "confirmPassword"
  | "currentPassword";

interface ErrorMessage {
  old_password?: string[];
  new_password?: string[];
  confirm_password?: string[];
}
interface TimeData {
  message: string;
  available_time: string;
  call_time: string;
  work_assign_time: string;
  break_time: string;
  idle_time: string;
}

type PhotoType = {
  photo: string;
};

const Profile = () => {
  const route = all_routes;
  const [passwordVisibility, setPasswordVisibility] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
    currentPassword: false,
  });

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [photo, setPhoto] = useState<File | null>(null);
  const [userDataData, setUserDataData] = useState({
    username: "",
    phone_number: "",
  });
  const { webApi, userData, userProfile } = useUserPermissions();
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const jwtToken = Cookies.get("authToken");
  const [errorMessage, setErrorMessage] = useState<ErrorMessage>({});
  const navigation = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [photo1, setPhoto1] = useState<PhotoType>({ photo: "" });
  const [isLoading1, setIsLoading1] = useState(false);
  const [userMonitoring, setUserMonitoring] = useState<TimeData>();
  const inactivityContext = useContext(InactivityContext);
  if (!inactivityContext) {
    throw new Error("Header must be used within an InactivityProvider");
  }
  const {setIsprofileChange } = inactivityContext;

  const userId = userData.id;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchPhoto = async () => {
    try {
      const response = await fetch(
        `${webApi}/user/add_update_userprofile_by_user/`,
        options
      );
      if (!response.ok) {
        throw new Error("Failed to fetch user data");
      }
      const data = await response.json();
      setPhoto1(data.data);
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    fetchPhoto();
  }, []);

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    setIsLoading(true);
    const data = {
      old_password: oldPassword,
      new_password: newPassword,
      confirm_password: confirmPassword,
    };
    try {
      const response = await fetch(`${webApi}/user/change_password_by_user/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData);
        throw new Error(errorData.detail || "Invalid email or password");
      }

      const result = await response.json();

      navigation(route.profile);

      // Reset form values
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setErrorMessage({});
      // Close the modal
      const submitBtn1 = document.getElementById("submit-btn7");
      if (submitBtn1) {
        submitBtn1.setAttribute("data-bs-dismiss", "modal");
        submitBtn1.click();
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      try {
        const response = await fetch(
          `${webApi}/user/add_update_userprofile_by_user/`,
          options
        );
        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }
        const data = await response.json();
        setUserDataData({
          username: data.data.username,
          phone_number: data.data.phone_number,
        });
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  useEffect(() => {
    const fetchMonitoringProfile = async () => {
      setIsLoading(true);

      try {
        const response = await fetch(
          `${webApi}/user_monitoring/agent_monitoring_profile/`,
          options
        );
        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }
        const data = await response.json();
        setUserMonitoring(data);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    fetchMonitoringProfile();
  }, []);

  const handleChange = (event: { target: { name: any; value: any } }) => {
    const { name, value } = event.target;
    setUserDataData((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleProfileSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/user/add_update_userprofile_by_user/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify(userDataData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData);
        throw new Error(errorData.detail || "Failed to update user profile");
      }

      const data = await response.json();
      setUserDataData({
        username: data.data.username || "",
        phone_number: data.data.phone_number || "",
      });

      setToastMessage(data.message);
      setshowSolidSuccessToast(true);
      setTimeout(() => {
        setshowSolidSuccessToast(false);
      }, 3000);
      if (!data) {
        throw new Error("No data received from server");
      }
    } catch (err) {
      if (err instanceof Error) {
        // Handle error accordingly
      } else {
        // Handle error accordingly
      }
    } finally {
      setIsLoading(false);
    }
  };
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);

  const handlePhotoChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    const file = event.target.files ? event.target.files[0] : null;
    setPhoto(file);
  };

  const updateUserProfile = async (photoFile: File | null) => {
    setIsLoading1(true);
    if (!photoFile) {
      setToastMessage("No photo file selected");
      setshowSolidSuccessToast(false);
      setTimeout(() => {
        setshowSolidSuccessToast(true);
      }, 3000);
      return;
    }
    try {
      const formData = new FormData();
      formData.append("photo", photoFile);

      const response = await fetch(
        `${webApi}/user/add_update_userprofile_by_user/`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update user profile");
      }

      const result = await response.json();
      setToastMessage(result.message);
      setIsprofileChange(true);
      setshowSolidSuccessToast(true);
      fetchPhoto();
      setTimeout(() => {
        setshowSolidSuccessToast(false);
      }, 3000);
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "An unexpected error occurred";
      setToastMessage(errorMessage);
      setshowSolidSuccessToast(false);
      setTimeout(() => {
        setshowSolidSuccessToast(true);
      }, 3000);
    } finally {
      setIsLoading1(false);
      
    }
  };

  const handleSubmit1 = (event: { preventDefault: () => void }) => {
    // setIsLoading1(true);
    event.preventDefault();

    try {
      if (photo) {
        updateUserProfile(photo);
      } else {
        // throw new Error("No photo selected");
        // setTimeout(() => {
        //   setshowSolidSuccessToast(true);
        // }, 3000);
      }
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "An unexpected error occurred";
      setToastMessage(errorMessage);
      setshowSolidSuccessToast(false);
      setTimeout(() => {
        setshowSolidSuccessToast(true);
      }, 3000);
    } finally {
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setshowSolidSuccessToast(false);
    }, 3000);
  }, [toastMessage]);

  useEffect(() => {
    console.log(userMonitoring);
  });

  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="d-md-flex d-block align-items-center justify-content-between border-bottom pb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Profile</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={route.adminDashboard}>Dashboard</Link>
                    </li>
                    {/* <li className="breadcrumb-item">
                      <Link to="#">Settings</Link>
                    </li> */}
                    <li className="breadcrumb-item active" aria-current="page">
                      Profile
                    </li>
                  </ol>
                </nav>
              </div>
              {/* <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                <div className="pe-1 mb-2">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Refresh</Tooltip>}
                  >
                    <Link
                      to="#"
                      className="btn btn-outline-light bg-white btn-icon me-1"
                    >
                      <i className="ti ti-refresh" />
                    </Link>
                  </OverlayTrigger>
                </div>
              </div> */}
            </div>
            <div className="d-md-flex d-block mt-3">
              <div className="settings-right-sidebar me-md-3 border-0">
                <div className="card">
                  <div className="card-header">
                    <h5>Personal Information</h5>
                  </div>
                  <div className="card-body">
                    <div className="settings-profile-upload">
                      <span
                        className="profile-pic"
                        style={{ width: "150px", height: "150px" }}
                      >
                        <img
                          src={
                            photo1.photo
                              ? `${webApi}${photo1.photo}`
                              : "https://cdn-icons-png.flaticon.com/128/11918/11918393.png"
                          }
                          alt="Profile"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </span>

                      <div className="title-upload">
                        <h5>Edit Your Photo</h5>
                        {/* <Link
                          to="#"
                          className="me-2"
                        >
                          Edit
                        </Link> */}
                        <input
                          type="file"
                          className="form-control"
                          multiple
                          id="image_sign"
                          onChange={handlePhotoChange}
                          style={{
                            width: "200px" /* Adjust the width as needed */,
                            height: "30px" /* Adjust the height as needed */,
                            padding: "5px" /* Adjust the padding as needed */,
                          }}
                        />

                        {/* Edit */}
                        <Link
                          to="#"
                          className="text-primary"
                          onClick={handleSubmit1}
                        >
                          {isLoading1 ? "Updating..." : "Update"}
                        </Link>
                      </div>
                    </div>

                    {/* <div className="profile-uploader profile-uploader-two mb-0"> */}

                    {/* <div id="frames"></div> */}
                    {/* </div> */}
                  </div>
                </div>
                {/* Grid Layout with 4 Cards */}
                <div className="card mt-3">
                  <div className="card-body">
                    <div className="row row-cols-1 row-cols-md-2 g-4">
                      <div className="col">
                        <div
                          className="card text-center"
                          style={{ backgroundColor: "#FFD700" }}
                        >
                          <div className="card-body">
                            {/* <h5>50.00%</h5> */}
                           <h5>{userMonitoring?.available_time}</h5>
                            <h4>Available</h4>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div
                          className="card text-center"
                          style={{ backgroundColor: "#87CEEB" }}
                        >
                          <div className="card-body">
                            
                            <h5>{userMonitoring?.call_time}</h5>
                            <h4>Call</h4>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div
                          className="card text-center"
                          style={{ backgroundColor: "#90EE90" }}
                        >
                          <div className="card-body">
                            {/* <h5>50.00%</h5> */}
                            <h5>{userMonitoring?.work_assign_time}</h5>
                            <h4> Work Assigned</h4>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div
                          className="card text-center"
                          style={{ backgroundColor: "#FFB6C1" }}
                        >
                          <div className="card-body">
                            {/* <h5>50.00%</h5> */}
                            <h5>{userMonitoring?.break_time}</h5>
                            <h4>Break</h4>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div
                          className="card text-center"
                          style={{ backgroundColor: "#FFD580" }}
                        >
                          <div className="card-body">
                            {/* <h5>50.00%</h5> */}
                            <h5>{userMonitoring?.idle_time}</h5>
                            <h4>Idle Time</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-fill ps-0 border-0">
                <form onSubmit={handleProfileSubmit}>
                  <div className="d-md-flex">
                    <div className="flex-fill">
                      <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <h5>Personal Information</h5>
                          <div className="mb-3">
                            <Link
                              to=""
                              className="form-text"
                              data-bs-toggle="modal"
                              data-bs-target="#change_password"
                            >
                              Click here to change your password
                            </Link>
                          </div>
                        </div>
                        <div className="card-body pb-0">
                          <div className="d-block d-xl-flex">
                            <div className="mb-3 flex-fill me-xl-3 me-0">
                              <label className="form-label">User Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="username"
                                value={userDataData.username}
                                onChange={handleChange}
                                placeholder="Enter User Name"
                                disabled
                              />
                            </div>
                            <div className="mb-3 flex-fill">
                              <label className="form-label">Phone Number</label>
                              <input
                                type="text"
                                className="form-control"
                                name="phone_number"
                                value={userDataData.phone_number}
                                onChange={handleChange}
                                placeholder="Enter Phone Number"
                                disabled
                              />
                            </div>
                          </div>
                          {/* <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ marginBottom: "5px" }}
                            disabled={isLoading}
                          >
                            {isLoading ? "Updating..." : "Update"}
                          </button> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
        {/* Edit Profile */}
        <div className="modal fade" id="edit_personal_information">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Personal Information</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">First Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter First Name"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Last Name"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">User Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter User Name"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Email"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Phone Number</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Phone Number"
                        />
                      </div>
                      <div className="mb-0">
                        <label className="form-label">Bio</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Bio"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                  >
                    Save Changes
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Profile */}
        {/* Edit Profile */}
        <div className="modal fade" id="edit_address_information">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Address Information</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Address"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Country</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Country"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">State/Province</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter State/Province"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter City"
                        />
                      </div>
                      <div className="mb-0">
                        <label className="form-label">Postal Code</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Postal Code"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                  >
                    Save Changes
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Profile */}
        {/* Change Password */}
        <div className="modal fade" id="change_password">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Change Password</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="submit-btn7"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Current Password</label>
                        <div className="pass-group">
                          <input
                            type={
                              passwordVisibility.oldPassword
                                ? "text"
                                : "password"
                            }
                            className={`form-control ${
                              errorMessage.old_password ? "is-invalid" : ""
                            }`}
                            onChange={(e) => setOldPassword(e.target.value)}
                            required
                            value={oldPassword}
                          />
                          <span
                            className={`ti toggle-passwords ${
                              passwordVisibility.oldPassword
                                ? "ti-eye"
                                : "ti-eye-off"
                            }`}
                            onClick={() =>
                              togglePasswordVisibility("oldPassword")
                            }
                          ></span>
                          {errorMessage.old_password && (
                            <div className="invalid-feedback">
                              {errorMessage.old_password}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">New Password</label>
                        <div className="pass-group">
                          <input
                            type={
                              passwordVisibility.newPassword
                                ? "text"
                                : "password"
                            }
                            className={`form-control ${
                              errorMessage.new_password ? "is-invalid" : ""
                            }`}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required={true}
                            value={newPassword}
                          />
                          {errorMessage.new_password && (
                            <div className="invalid-feedback">
                              {errorMessage.new_password}
                            </div>
                          )}
                          <span
                            className={`ti toggle-passwords ${
                              passwordVisibility.newPassword
                                ? "ti-eye"
                                : "ti-eye-off"
                            }`}
                            onClick={() =>
                              togglePasswordVisibility("newPassword")
                            }
                          ></span>
                        </div>
                      </div>
                      <div className="mb-0">
                        <label className="form-label">Confirm Password</label>
                        <div className="pass-group">
                          <input
                            type={
                              passwordVisibility.confirmPassword
                                ? "text"
                                : "password"
                            }
                            className={`form-control ${
                              errorMessage.confirm_password ? "is-invalid" : ""
                            }`}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            value={confirmPassword}
                          />
                          {errorMessage.confirm_password && (
                            <div className="invalid-feedback">
                              {errorMessage.confirm_password}
                            </div>
                          )}
                          <span
                            className={`ti toggle-passwords ${
                              passwordVisibility.confirmPassword
                                ? "ti-eye"
                                : "ti-eye-off"
                            }`}
                            onClick={() =>
                              togglePasswordVisibility("confirmPassword")
                            }
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button type="submit" className="btn btn-primary">
                    {isLoading ? (
                      <i className="spinner-border spinner-border-sm"></i>
                    ) : (
                      <>Save Changes</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Toast
          show={showSolidSuccessToast}
          onClose={handleSolidSuccessToastClose}
          id="solidSuccessToast"
          className="colored-toast bg-success text-fixed-white"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 1050,
          }}
        >
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
        {/* /Change Password */}
      </>
    </div>
  );
};

export default Profile;
